import type { SalesChecklistSection } from "@expert/contentful";

import { richPhraseToPlainText } from "../../RichPhrase";

/**
 * Collapses 3002's "Enrollment transparency" section to a single price point when
 * `Sales-isRichBenefitsEnabled` is on. The copy is defined here in code, so a wording change is a code
 * change.
 *
 * The section ships two items, BILLING and ASK_SALE. This keeps BILLING (so it stays a checkable,
 * detectable point and keeps its tooltip/subheading) with new copy, and drops ASK_SALE.
 *
 * `==...==` is the shared purple "say these exact words" highlight.
 */
const PRICE_RICH_PHRASE = "==And here’s the price for all of that. It’s only $25 plus tax, per month.==";

// Replaces BILLING's "Say these exact words" — the purple highlight already signals that.
const PRICE_SUBHEADING = "The price";

/** Returns `section` untouched unless it carries a BILLING item, so any other section passes through. */
export function toPriceOnlyEnrollmentTransparency(section: SalesChecklistSection): SalesChecklistSection {
    const billing = section.checklistItems.find((item) => item.key === "BILLING");
    if (!billing) return section;
    return {
        ...section,
        checklistItems: [
            {
                ...billing,
                subheading: PRICE_SUBHEADING,
                // ChecklistItem renders `richPhrase`; `phrase` is required by the type, so derive it
                // rather than keep a second copy of the line.
                phrase: richPhraseToPlainText(PRICE_RICH_PHRASE),
                richPhrase: PRICE_RICH_PHRASE,
            },
        ],
    };
}
